<template>
  <div>
    <!-- 配送单待支付 -->
    <baseBreadcrumb :page="$t('message.deliveryOrderToBePaid')" :menu="$t('message.porder')" />
    <porderBaseTable :status="'配送单待支付'" />
  </div>
</template>
<script>
import porderBaseTable from "@/components/porder/porderBaseTable/index";
export default {
  components: { porderBaseTable },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang='scss' scoped></style>